/**
 *  Created by long.wang on 2019/4/11
 */
import development from './config.dev'
import test from './config.test'
import production from './config.production'

let configs = {
  development,
  test,
  production
}
console.log('-----config -----process.env.NODE_ENV:', process.env.NODE_ENV)
export default configs[process.env.NODE_ENV]
